<div class="bloc-content-body">
  <p class="current-step">Adresse de livraison</p>
  @if (form) {
    <form class="form w-100" [formGroup]="form" (ngSubmit)="submit()">
      <div class="bloc-input civility">
        <p class="headline">Civilité<sup>*</sup></p>
        <div class="grid">
          <label for="radioMr">
            <input id="radioMr" type="radio" name="shippingAddressCivility" value="Mr" formControlName="shippingAddressCivility" />
            Monsieur
          </label>
          <label for="radioMme">
            <input id="radioMme" type="radio" name="shippingAddressCivility" value="Mme" formControlName="shippingAddressCivility" />
            Madame
          </label>
        </div>
      </div>
      <div class="bloc-input">
        <label for="shippingAddressLastName">Nom<sup>*</sup></label>
        <input
          type="text"
          id="shippingAddressLastName"
          name="shippingAddressLastName"
          formControlName="shippingAddressLastName"
          autocomplete="family-name"
          placeholder="Votre nom"
          maxlength="18"
          required
          />
        @if (formSubmitted && getError('shippingAddressLastName')) {
          <small class="error-message">
            {{ getError('shippingAddressLastName') }}
          </small>
        }
      </div>
      <div class="bloc-input">
        <label for="shippingAddressFirstName">Prénom<sup>*</sup></label>
        <input
          type="text"
          id="shippingAddressFirstName"
          name="shippingAddressFirstName"
          formControlName="shippingAddressFirstName"
          autocomplete="first-name"
          placeholder="Votre prénom"
          maxlength="18"
          required
          />
        @if (formSubmitted && getError('shippingAddressFirstName')) {
          <small class="error-message">
            {{ getError('shippingAddressFirstName') }}
          </small>
        }
      </div>
      <div class="bloc-input">
        <label for="address">Adresse<sup>*</sup></label>
        <input
          type="text"
          id="address"
          name="address"
          formControlName="address"
          placeholder="Votre adresse"
          required
          />
        @if (formSubmitted && getError('address')) {
          <small class="error-message">
            {{ getError('address') }}
          </small>
        }
      </div>
      <div class="bloc-input">
        <label for="addressComplement">Complément d'adresse</label>
        <input
          type="text"
          id="addressComplement"
          name="addressComplement"
          formControlName="addressComplement"
          placeholder="Votre complément d'adresse "
          />
        @if (formSubmitted && getError('addressComplement')) {
          <small class="error-message">
            {{ getError('addressComplement') }}
          </small>
        }
      </div>
      <div class="bloc-input">
        <label for="zipCode">Code postal<sup>*</sup></label>
        <input
          type="text"
          id="zipCode"
          name="zipCode"
          formControlName="zipCode"
          placeholder="Votre code postal"
          required
          />
        @if (formSubmitted && getError('zipCode')) {
          <small class="error-message">
            {{ getError('zipCode') }}
          </small>
        }
      </div>
      <div class="bloc-input">
        <label for="city">Ville<sup>*</sup></label>
        <input
          type="text"
          id="city"
          name="city"
          formControlName="city"
          placeholder="Votre ville"
          required
          />
        @if (formSubmitted && getError('city')) {
          <small class="error-message">
            {{ getError('city') }}
          </small>
        }
      </div>
      <div class="row w-100 pt-3 text-center">
        <div class="col-12 w-100 cta_container">
          <button type="submit" class="cta_btn level_2 column">Valider<span></span></button>
        </div>
      </div>
    </form>
  }
</div>
